import { useMemo } from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { useStore } from "../../utils/ctx/SellingPageContext";
import { SELLING_SEARCH_ROUTE } from "../../utils/routes/const";

const ClearFilters = () => {
  const {t} = useTranslation();
  const [store, setStore] = useStore((store) => store);
  const { preFilteredBrand, preFilteredModel } = useMemo(() => store, [store]);

  return (
    <button
    onClick={() => {
      setStore({ searchQuery: '', selectedBrands: [], selectedModels: [], page: 1 })
      if ((preFilteredBrand || preFilteredModel) && typeof window !== "undefined") {
        window.location.href = SELLING_SEARCH_ROUTE
      }
    }}
    className="p-4 border border-primary"
    type="button"
  >
    {t("general.filters.clear")}
  </button>
  )
}

export default ClearFilters;
